// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dff4f03d","455":"acd34329","977":"eb8771e9"}[chunkId] + ".chunk.js";
};